import SVG from "../../SVG";

export default function NavContent({ items = [] }) {
  return (
    <div className="h-full flex items-center gap-4">
      {items.map((label, index) => (
        <div key={label} className="flex items-center gap-4">
          <span className="text-base font-light text-zi-text-light dark:text-zi-text-dark">
            {label}
          </span>
          {index < items.length - 1 && (
            <SVG name="arrowLeft" classname="size-2 stroke-zi-blue-dark dark:stroke-white" />
          )}
        </div>
      ))}
    </div>
  )
}